import { createSelector } from 'reselect'

import { RESTART_SALE, CANCEL_SALE, CHANGE_BRAND } from '../constants/messages'

import { RootState } from '~/core/store/root.reducer'

const getModal = (state: RootState) => state.modal

export const selectModal = createSelector(getModal, (modal) => modal)

export const selectIsRestartModal = createSelector(selectModal, (modal) =>
  [RESTART_SALE.title, CANCEL_SALE.title, CHANGE_BRAND.title].includes(modal.title || ''),
)

export default selectModal
